import { createApp } from 'vue';
import Author from './Author.vue';
import './author.css';
import { router } from './router';
import './lib/monacoEnv';
import '../lib/ripple';
import gsap from 'gsap';
import { ifNotAuthedRedirect } from './lib/authRedirect';
import { reauth } from '../lib/reauth';
import { updateJWT } from './lib/useJWT';

gsap.config({ nullTargetWarn: false });

ifNotAuthedRedirect();
updateJWT();
setInterval(reauth, 10 * 60 * 1000);

window.addEventListener('submit', e => e.preventDefault());

createApp(Author).use(router).mount('#author');
